"use client";

import React, { useState } from "react";

interface IProps {
  fragmentName: string;
  payload: any;
}


export const FragmentNotRegisteredError: React.FC<IProps> = ({
  fragmentName,
  payload
}) => {
  const [show, setShow] = useState(true);

  return (
    <div className="bg-gray-100 pt-2 pb-6 px-2 w-full mb-2 rounded-lg border-red-500 border-l-4 text-black">
      <h2 className="text-lg text-red-500">
        Page Builder: Including_Exception
      </h2>
      <h2 className="text-ui-medium-text-desktop py-2">
        Fragment not registered
      </h2>
      <p className="mb-2">
        Fragment <b className="italic">{fragmentName}</b> is not registered
      </p>
      <p className="p-1 border-l-4 border-orange-400 bg-orange-100 mt-2 flex flex-row">
        TIP: Please make sure that you have in your ui_fragments.ts
        configuration file something like
      </p>
      <pre className="whitespace-pre-wrap">
        {`
          {
            ...
            ${fragmentName}: "${
              "..." + "/{Design System Component Name}"
                  }", # make sure this component exist before registering
            ...
          }
        `}
      </pre>
      <label>
        <input
          type="checkbox"
          checked={show}
          onChange={(evt) => setShow(evt.currentTarget.checked)}
        />{" "}
        Show/Hide Payload
      </label>
      {show && (
        <React.Fragment>
          <h4 className="pt-2 pb-1 text-xl">Using Payload</h4>
          <pre className="whitespace-pre-wrap">
            {JSON.stringify(payload, null, "  ")}
          </pre>
        </React.Fragment>
      )}
    </div>
  );
};
